/**
 * plugin.js
 *
 * Copyright, BuboBox
 * Released under MIT License.
 *
 * License: https://www.bubobox.com
 * Contributing: https://www.bubobox.com/contributing
 */

/*global tinymce:true */

/* tinymce.PluginManager.add('example', function(editor, url) {
    // Add a button that opens a window
    editor.addButton('example', {
      text: 'My button',
      icon: false,
      onclick: function() {
        // Open window
        editor.windowManager.open({
          title: 'Example plugin',
          body: [
            {type: 'textbox', name: 'title', label: 'Title'}
          ],
          onsubmit: function(e) {
            // Insert content when the window form is submitted
            editor.insertContent('Title: ' + e.data.title);
          }
        });
      }
    });
  
    // Adds a menu item to the tools menu
    editor.addMenuItem('example', {
      text: 'Example plugin',
      context: 'tools',
      onclick: function() {
        // Open window with a specific url
        editor.windowManager.open({
          title: 'TinyMCE site',
          url: 'https://www.tinymce.com',
          width: 800,
          height: 600,
          buttons: [{
            text: 'Close',
            onclick: 'close'
          }]
        });
      }
    });
  
    return {
      getMetadata: function () {
        return  {
          name: "Example plugin",
          url: "http://exampleplugindocsurl.com"
        };
      }
    };
  }); */

  tinymce.PluginManager.add('variable', function(editor) {
    editor.settings.convert_urls = false
    editor.settings.relative_urls = false

    var VK = tinymce.util.VK;

    /**
     * Object that is used to replace the variable string to be used
     * in the HTML view
     * @type {object}
     */
    var mapper = editor.getParam("variable_mapper", {});

    /**
     * define a list of variables that are allowed
     * if the variable is not in the list it will not be automatically converterd
     * by default no validation is done
     * @todo  make it possible to pass in a function to be used a callback for validation
     * @type {array}
     */
    var valid = editor.getParam("variable_valid", null);

    /**
     * Get custom variable class name
     * @type {string}
     */
    var className = editor.getParam("variable_class", "variable");

    /**
     * Prefix and suffix to use to mark a variable
     * @type {string}
     */
    var prefix = editor.getParam("variable_prefix", "{{");
    var suffix = editor.getParam("variable_suffix", "}}");
    var stringVariableRegex = new RegExp(prefix + '([a-zA-Z0-9. _#/\-]*)?' + suffix, 'g');

    /**
     * check if a certain variable is valid
     * @param {string} name
     * @return {bool}
     */
    function isValid( name )
    {

        if( ! valid || valid.length === 0 )
            return true;

        var validString = '|' + valid.join('|') + '|';

        return validString.indexOf( '|' + name + '|' ) > -1 ? true : false;
    }

    function getMappedValue( cleanValue ) {
        if(typeof mapper === 'function')
            return mapper(cleanValue);

        return mapper.hasOwnProperty(cleanValue) ? mapper[cleanValue] : cleanValue;
    }

    /**
     * Strip variable to keep the plain variable string
     * @example "{test}" => "test"
     * @param {string} value
     * @return {string}
     */
    function cleanVariable(value) {
        return value.replace(/[^a-zA-Z0-9._#/\-]/g, "");
    }

    /**
     * convert a text variable "x" to a span with the needed
     * attributes to style it with CSS
     * @param  {string} value
     * @return {string}
     */
    function createHTMLVariable( value ) {

        var cleanValue = cleanVariable(value);

        // check if variable is valid
        if( ! isValid(cleanValue) )
            return value;

        var cleanMappedValue = getMappedValue(cleanValue);

        editor.fire('variableToHTML', {
            value: value,
            cleanValue: cleanValue
        });

        var variable = prefix + cleanValue + suffix;
        return '<span class="' + className + '" data-original-variable="' + variable.replace(prefix, '').replace(suffix, '') + '" contenteditable="false">' + cleanMappedValue + '</span>&nbsp;';

    }

    /**
     * convert a text variable "x" to its clean form
     * @param  {string} value
     * @return {string}
     */
    function createCleanVariable( value ) {

        var cleanValue = cleanVariable(value);

        // check if variable is valid
        if( ! isValid(cleanValue) )
            return value;

        var cleanMappedValue = getMappedValue(cleanValue);

        editor.fire('variableToHTML', {
            value: value,
            cleanValue: cleanValue
        });

        return cleanMappedValue;

    }

    /**
     * convert variable strings into html elements
     * @return {void}
     */
    function stringToHTML()
    {
        var nodeList = [];

        // find nodes that contain a string variable
        tinymce.walk(editor.getBody(), function(n) {
            if (n.nodeType == 3 && n.nodeValue && stringVariableRegex.test(n.nodeValue)) {
                nodeList.push(n);
            }
        }, 'childNodes');

        // loop over all nodes that contain a string variable
        for (var i = 0; i < nodeList.length; i++) {
            var hasParent = false;
            tinymce.walk( nodeList[i], function(n) {
                if (n.nodeType == 3 && n.getAttribute('data-original-variable')) {
                    hasParent = true;
                }
            }, 'parentNodes');
            if (!hasParent){
            }
            nodeList[i].nodeValue = nodeList[i].nodeValue.replace(stringVariableRegex, createCleanVariable);
        }
    }

    /**
     * convert HTML variables back into their original string format
     * for example when a user opens source view
     * @return {void}
     */
    function htmlToString()
    {
        var nodeList = [];

            // find nodes that contain a HTML variable
        tinymce.walk( editor.getBody(), function(n) {
            if (n.nodeType == 1) {
                var original = n.getAttribute('data-original-variable');
                if (original !== null) {
                    nodeList.push(n);
                }
            }
        }, 'childNodes');

        // loop over all nodes that contain a HTML variable
        for (var i = 0; i < nodeList.length; i++) {
            nodeList[i].lastChild.nodeValue = prefix + nodeList[i].getAttribute('data-original-variable').toString() + suffix;
            tinymce.walk( nodeList[i], function(n) {
                if (n.nodeType == 3) {
                    n.nodeValue =  prefix + nodeList[i].getAttribute('data-original-variable').toString() + suffix;
                }
            }, 'childNodes');
        }

    }

    function setCursor(selector) {
        var ell = editor.dom.select(selector)[0];
        if(ell) {
            var next = ell.nextSibling;
            editor.selection.setCursorLocation(next);
        }
    }

    /**
     * handle formatting the content of the editor based on
     * the current format. For example if a user switches to source view and back
     * @param  {object} e
     * @return {void}
     */
    function handleContentRerender(e) {
        // store cursor location
        return e.format === 'raw' ? stringToHTML() : htmlToString();
        // restore cursor location
    }

    /**
     * insert a variable into the editor at the current cursor location
     * @param {string} value
     * @return {void}
     */
    function addVariable(value, title) {
        var htmlVariable = '';
        if (uglify) {
            var htmlVariable = prefix + value + suffix;
        } else {
            var  htmlVariable = createHTMLVariable(value);
        }
        editor.execCommand('mceInsertContent', false, htmlVariable);
    }

    function isVariable(element) {
        if(typeof element.getAttribute === 'function' && element.hasAttribute('data-original-variable'))
            return true;

        return false;
    }

    /**
     * Trigger special event when user clicks on a variable
     * @return {void}
     */
    function handleClick(e) {
        var target = e.target;

        if(!isVariable(target))
            return null;

        var value =  prefix + target.getAttribute('data-original-variable') + suffix;
        editor.fire('variableClick', {
            value: cleanVariable(value),
            target: target
        });
    }

    function preChange(e){
        tinymce.walk(editor.getBody(), function(n) {
            if (n.nodeType == 1 && n.hasAttribute('contentEditable')) {
                n.setAttribute('contentEditable', false);
            }
        }, 'childNodes');
    };
    function postChange(e){
        tinymce.walk(editor.getBody(), function(n) {
            if (n.nodeType == 1 && n.hasAttribute('contentEditable')) {
                n.setAttribute('contentEditable', true);
            }
        }, 'childNodes');
    };

    function setCallbacks() {
        
        editor.on('mousedown', preChange );
        editor.on('click', postChange );
        editor.on('keydown', preChange );
        editor.on('keyup', postChange );

        editor.on('nodechange', stringToHTML );
        editor.on('keyup', stringToHTML );
        editor.on('beforegetcontent', handleContentRerender);
        editor.on('click', handleClick);
    }

    this.addVariable = addVariable;

    var ddfGroups = editor.getParam("ddf_groups", {});

    var ddfs = editor.getParam("ddfs", {}); 

    var uglify = editor.getParam("dff_ugly", false); 

    var tempGroupName;
    var menuItems = [];

    function createDdfMenu() {
        var subitems = {};
        for (i = 0; i < ddfGroups.length; i++) {
            var tempArray = [];
            tempArray[i] = [];
            tempGroupName = ddfGroups[i];
            for (j = 0; j < ddfs.length; j++) {
                if (ddfs[j].group == tempGroupName) {
                    var variableKey = ddfs[j].variableKey;
                    var variableTitle = ddfs[j].title;
                    var button = {
                        text: ddfs[j].title,
                        type: 'menuitem',
                        variableKey: ddfs[j].variableKey,
                        onAction: function (key, title) {
                            console.log(key);
                            console.log(title);
                            addVariable(key, title);
                        }.bind(null, variableKey, variableTitle)
                    }
                    tempArray[i].push(button);
                }
            }
            
            for (let k = 0; k < tempArray[i].length; k++) {
                if (!subitems[tempGroupName]) {
                    subitems[tempGroupName] = [];
                }
                subitems[tempGroupName].push(tempArray[i][k]);
            }
            menuItems[i] = {
                text: tempGroupName,
                type: 'nestedmenuitem',
                icon: null,
                getSubmenuItems: function(groupName) { return subitems[groupName] }.bind(null, tempGroupName)
            };
        }
        return menuItems;
    }

    if (ddfs) {
        editor.ui.registry.addMenuButton('variable', {
        text: 'Insert DDF',
        fetch: function(callback) {
            var items = createDdfMenu();
            callback(items);

        }
        });
    }

    if (!uglify) {
        setCallbacks();
    }

});